import React, { Fragment, useState } from "react";
import moment from "moment";
import { FaLock } from "react-icons/fa";
import { BiCommentDetail } from "react-icons/bi";
import { RiPencilFill } from "react-icons/ri";
import { ImClock } from "react-icons/im";
import { GoAlert } from "react-icons/go";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import ShiftPreviewTooltip from 'components/Shifts/ShiftPreviewTooltip';
import PlanShiftHoverMenu from "components/Plans/PlanShiftHoverMenu";
import ShiftObservationTooltip from "components/Plans/ShiftObservationTooltip";
import { resolveDayAssignments } from "utils/planWorkflowAbsences";
import { getContrastColor } from "utils/utils";
import { getInternalShiftPlanFromDropEvent } from "utils/planDaySelection";

const blockContextMenu = (e) => {
	e.preventDefault();
	e.stopPropagation();
};

const hasShiftComments = (item) =>
	typeof item?.comments === "string" && item.comments.trim() !== "";

const getRowContent = (
	props,
	hoveredAssignmentId,
	setHoveredAssignmentId,
	isDragging,
	setIsDragging,
	dragOverCell,
	setDragOverCell,
	dragTarget,
	setDragTarget
) =>
	props.plan_days.map((d, i) => {
		// console.log(props);
		const key = `${d.day}_${i}`;

		return (
			<tr key={key}>
				{getDayHeader(props, d, i)}
				{getPlanRowContent(
					props,
					hoveredAssignmentId,
					setHoveredAssignmentId,
					isDragging,
					setIsDragging,
					dragOverCell,
					setDragOverCell,
					dragTarget,
					setDragTarget,
					d,
					i
				)}
			</tr>
		);
	});

const getDayHeader = (props, d, i) => {
	const day = moment(d.day).format("ddd");
	const dayNum = moment(d.day).format("DD/MM");
	const details = d.details;

	// console.log(d);
	let day_type;
	const isToday = moment(d.day).isSame(moment(), "day");

	// TODO adaptar multigrup
	if (details.length > 0) {
		if (details[0].special_day) day_type = details[0].special_day.day_type;

		if (details[0].weekday) day_type = details[0].weekday.day_type;
	}

	const color = day_type.color;
	const key = `th_${day}`;
	return (
		<th
			className={`th-day th-day-extended th-selectable  ${isToday ? "today" : ""
				}`}
			style={{ color: color }}
			key={key}
			onClick={() => props.handleColumnSelection(i)}
		>
			<div className="th-day-content">
				<span className="span-day">{day}</span>
				<span className="span-num">{dayNum}</span>
			</div>
		</th>
	);
};

// contenido celdas turnos
const getPlanRowContent = (
	props,
	hoveredAssignmentId,
	setHoveredAssignmentId,
	isDragging,
	setIsDragging,
	dragOverCell,
	setDragOverCell,
	dragTarget,
	setDragTarget,
	day,
	row_inv
) =>
	props.plan_assignments.map((plan_assignment, i_inv) => {
		const employee = plan_assignment.employee;
		const item = plan_assignment.plans.find((item) => item.day === day.day);
		const checked = item ? item.checked : false;

		// fix para invertir filas y columnas
		const row = i_inv;
		const i = row_inv;

		const cut =
			props.day_selection_copy.length > 0 &&
			props.day_selection_copy.find(
				(item) => item.row === row && item.index === i
			);
		const dashed =
			props.day_selection_dashed.length > 0 &&
			props.day_selection_dashed.find(
				(item) => item.row === row && item.index === i
			);
		// const cut = props.day_selection_copy.length > 0;
		const key = `td_${day.day}_${row}_${i}`;

		if (item.active) {
			return (
				<td
					key={key}
					className={`shift-cell shift-cell-intervals btn-checkbox 
					${checked ? "active" : ""} 
					${cut ? "cut" : ""} 
					${dashed ? "dashed" : ""}
					${dragOverCell === `${row}-${i}` ? "drag-over" : ""}
					${dragTarget?.key === `${row}-${i}` && dragTarget.zone === "top" ? "drag-over-top" : ""}
  					${dragTarget?.key === `${row}-${i}` && dragTarget.zone === "bottom" ? "drag-over-bottom" : ""}
					`}
					onDragOver={(e) => onDragOverSplit(e, row, i, setDragOverCell, setDragTarget)}
					onDragLeave={(e) => onDragLeaveSplit(e, setDragOverCell, setDragTarget)}
					onDrop={(e) => onShiftsDrop(e, props, row, i, setIsDragging, setDragOverCell, dragTarget, setDragTarget)}
					data={{ action: "paste-shift" }}
				>
					{dragOverCell === `${row}-${i}` && (
						<div className="split-guides">
							<div className={`split-half top ${dragTarget?.zone === "top" ? "active" : ""}`}>Mover</div>
							<div className={`split-half bottom ${dragTarget?.zone === "bottom" ? "active" : ""}`}>Copiar</div>
						</div>
					)}
					<div className="react-contextmenu-wrapper" onContextMenu={blockContextMenu}>
						<input
							type="checkbox"
							id={`day_${row}_${i}`}
							onChange={(e) =>
								props.hasPrivileges && props.handleDaySelection(row, i, e)
							}
							checked={checked}
						/>
						<label
							htmlFor={`day_${row}_${i}`}
							className="btn-check-label"
							draggable={props.hasPrivileges}
							onDragEnter={(e) => props.selectSingleDay(row, i)}
						></label>

						<ul className="shift-list-items">
							{getAssignedShifts(
								props,
								hoveredAssignmentId,
								setHoveredAssignmentId,
								isDragging,
								setIsDragging,
								employee,
								item,
								row,
								i
							)}
						</ul>
					</div>
				</td>
			);
		} else {
			return <td key={i} className="shift-cell disabled"></td>;
		}
	});

const getAssignedShifts = (
	props,
	hoveredAssignmentId,
	setHoveredAssignmentId,
	isDragging,
	setIsDragging,
	employee,
	sp_item,
	row,
	index
) =>
	resolveDayAssignments(
		sp_item.assignments,
		props.default_shift,
		true
	).map((item) => {
		const shift = item.shift;

		// time intervals editados
		// const editedTimes = item.time_intervals && item.time_intervals.find(item => item.time_type.work_time === false);
		const key = item.id === -1 ? `empty-${row}-${index}` : item.id; // Usamos el id de la asignación como key
		const editedTimes =
			item.time_intervals_from_manual &&
			item.time_intervals &&
			item.time_intervals.length > 0;

		const day_selection = props.day_selection;
		const plan = {
			employee: employee,
			day: sp_item.day,
			shift_plan: item,
		};

		const shiftname = shift.description
			? shift.name + " - " + shift.description
			: shift.name;

		const tooltip_alerta = (
			<Tooltip className="tooltip-alerta">
				<ul>
					{item.alert_min_rest_hours && (
						<li>
							<GoAlert className="tooltip-icon icon-alert" /> No se cumple el
							mínimo de horas entre turnos
						</li>
					)}
					{item.alert_max_consecutive_working_days && (
						<li>
							<GoAlert className="tooltip-icon icon-alert" /> No se cumple el
							máximo de días de trabajo consecutivos
						</li>
					)}
				</ul>
			</Tooltip>
		);

		// const tooltip_turno = <Tooltip className="tooltip-shift"><ShiftPreviewTooltip shift={shift} time_intervals={shift.time_intervals} /></Tooltip>;

		return (
			// <OverlayTrigger overlay={tooltip_turno}>
			<li
				key={item.id}
				title={`${shiftname}`}
				className="shift-item"
				style={{
					backgroundColor: shift.background_color && shift.background_color,
					borderColor: shift.border_color
						? shift.border_color
						: shift.background_color || undefined,
					color: getContrastColor(shift.background_color),
					cursor: "grab",
				}}
				draggable={props.hasPrivileges}
				onDragStart={(e) => {
					setIsDragging(true);
					onShiftDragStart(e, plan);
				}}
				onDragEnd={(e) => {
					setIsDragging(false);
					// Limpiar atributo de debugging
					e.target.removeAttribute('data-drag-plan');
				}}
				onClick={(e) => {
					e.stopPropagation();
					props.hasPrivileges && props.handleDaySelection(row, index, e);
				}}
				onMouseEnter={() => {
					if (!isDragging && props.hasPrivileges) {
						setTimeout(() => setHoveredAssignmentId(key), 5);
						//setHoveredAssignmentId(key)
					}
				}}
				onMouseLeave={() => {
					if (!isDragging && props.hasPrivileges && !props.isAddingShift) {
						// setTimeout(() => setHoveredAssignmentId(null), 5);
						setHoveredAssignmentId(null);
					}
				}}
			>
				<div className="react-contextmenu-wrapper" onContextMenu={blockContextMenu}>
					{shift.id !== props.default_shift?.id ? shift.name : "-"}

					{item.locked && <FaLock className="plan-icon icon-locked" />}
					{item.time_intervals_from_override_time_registrations && (
						<ImClock className="plan-icon icon-clock" />
					)}
					{hasShiftComments(item) && (
						<BiCommentDetail className="plan-icon icon-comments" />
					)}
					{(item.alert_min_rest_hours ||
						item.alert_max_consecutive_working_days) && (
							<OverlayTrigger overlay={tooltip_alerta}>
								<GoAlert className="plan-icon icon-alert" />
							</OverlayTrigger>
						)}
					{editedTimes && <RiPencilFill className="plan-icon icon-edited" />}
				</div>

				{hoveredAssignmentId === key &&
					!isDragging &&
					hasShiftComments(item) && (
						<ShiftObservationTooltip comments={item.comments} />
					)}
				{hoveredAssignmentId === key && (
					<PlanShiftHoverMenu
						plan={plan}
						defaultShiftId={props.default_shift?.id}
						onAdd={(update_employee_ids) =>
							props.updateEmployeeIdsAndGetAllAssignments(update_employee_ids)
						}
						onShiftAssigned={props.onShiftAssigned}
						onEdit={() => props.handleEditShift(plan)}
						onDelete={() => props.handleRemoveShift(plan, plan.shift_plan.id)}
					/>
				)}
			</li>
			// </OverlayTrigger>
		);
	});

// const onDragOver = (e, row, index, setDragOverCell) => {
// 	e.preventDefault(); // Necesario para permitir el drop

// 	const cellKey = `${row}-${index}`;
// 	setDragOverCell(cellKey);
// };

const onDragOverSplit = (e, row, index, setDragOverCell, setDragTarget) => {
	e.preventDefault();

	const cell = e.currentTarget; // la <td>
	const rect = cell.getBoundingClientRect();
	const y = e.clientY - rect.top;
	const zone = y < rect.height / 2 ? "top" : "bottom";

	const key = `${row}-${index}`;

	setDragOverCell(key);

	// nuevo estado con la zona
	setDragTarget((prev) => {
		if (!prev || prev.key !== key || prev.zone !== zone) {
			return { key, zone };
		}
		return prev;
	});

	// feedback del cursor (opcional)
	try {
		e.dataTransfer.dropEffect = zone === "top" ? "move" : "copy";
	} catch (_) { }
};

const onDragLeaveSplit = (e, setDragOverCell, setDragTarget) => {
	// si el puntero realmente sale de la celda (no entra en un hijo)
	const related = e.relatedTarget;
	if (!e.currentTarget.contains(related)) {
		setDragOverCell(null);
		setDragTarget(null);
	}
};


const onShiftsDrop = (
	e,
	props,
	row,
	i,
	setIsDragging = () => { },
	setDragOverCell = () => { },
	dragTarget = null,
	setDragTarget = () => { }
) => {
	e.preventDefault();
	e.stopPropagation();

	setIsDragging(false);
	setDragOverCell(null);
	const zone = dragTarget && dragTarget.key === `${row}-${i}` ? dragTarget.zone : "top";
	setDragTarget(null);

	const dropModeFromZone = zone === "bottom" ? "copy" : "move";
	const dropModeWithModifier =
		(e.ctrlKey || e.altKey || e.metaKey) && dropModeFromZone === "move"
			? "copy"
			: dropModeFromZone;

	const shiftPlan = getInternalShiftPlanFromDropEvent(e);

	if (shiftPlan) {
		if (dropModeWithModifier === "copy") {
			props.handleCopyPasteShift(shiftPlan, row, i);
			return;
		}

		props.handleMoveShift(shiftPlan, row, i);
		return;
	}

	props.handleDayMenuClick(e, {
		action: "paste-shift",
		row,
		index: i,
	});
};

const onShiftDragStart = (e, plan) => {
	// Verificar que el plan tiene la estructura esperada
	if (!plan || !plan.shift_plan) {
		e.preventDefault();
		return;
	}
	
	try {
		const planData = JSON.stringify(plan);
		
		// Usar múltiples formatos para asegurar compatibilidad
		e.dataTransfer.setData("shift", planData);
		e.dataTransfer.setData("text/plain", planData);
		e.dataTransfer.setData("application/json", planData);
		e.dataTransfer.effectAllowed = "copyMove";
		
		// Almacenar también en el elemento para debugging
		e.target.setAttribute('data-drag-plan', planData);
		
	} catch (error) {
		e.preventDefault();
	}
};

const PlanTableBodyInverted = (props) => {
	//console.log(props);
	const [hoveredAssignmentId, setHoveredAssignmentId] = useState(null);
	const [isDragging, setIsDragging] = useState(false);
	const [dragOverCell, setDragOverCell] = useState(null);
	const [dragTarget, setDragTarget] = useState(null);

	return (
		<tbody>
			{getRowContent(
				props,
				hoveredAssignmentId,
				setHoveredAssignmentId,
				isDragging,
				setIsDragging,
				dragOverCell,
				setDragOverCell,
				dragTarget,
				setDragTarget
			)}
		</tbody>
	);
};

export default PlanTableBodyInverted;
